import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import Carousel from 'react-material-ui-carousel';
import { NoticiaAnexo } from '../../../../../typesSite/noticia/NoticiaAnexo';
import DownloadAnexoButton from '../create/DownloadAnexoButton';
import { gerarUrlCapa } from '../create/gerarUrlCapa';

type Props = {
  noticiaAnexos: NoticiaAnexo[] | null;
};

export function NoticiaViewAnexosCarrossel({ noticiaAnexos }: Props) {
  if (!noticiaAnexos || noticiaAnexos.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary">
        Nenhum anexo encontrado.
      </Typography>
    );
  }

  const imagens = noticiaAnexos.filter(a => a.tipo.toUpperCase().includes('IMAGE'));
  const outros = noticiaAnexos.filter(a => !a.tipo.toUpperCase().includes('IMAGE'));

  return (
    <Box mt={4}>
      {/* Carrossel de imagens */}
      {imagens.length > 0 && (
        <>
          <Typography variant="h6" color="primary" gutterBottom padding={2}>
            Galeria de imagens
          </Typography>

          <Carousel autoPlay={false} navButtonsAlwaysVisible>
            {imagens.map((imagem, index) => (
              <Box
                key={index}
                display="flex"
                flexDirection="column"
                alignItems="center"
                sx={{
                  width: '100%',
                  minHeight: '300px',  // Definindo altura mínima para o carrossel
                  height: 'auto',       // Permite o ajuste da altura conforme necessário
                  display: 'flex',
                  justifyContent: 'center',  // Garante que o conteúdo fique centralizado
                }}
              >
                <Box
                  component="img"
                  src={gerarUrlCapa(imagem.path, 'NOTICIA')}
                  alt={imagem.nomeOriginal}
                  sx={{
                    width: '100%',
                    maxWidth: { xs: '300px', sm: '400px', md: '500px' },
                    maxHeight: { xs: '250px', sm: '400px', md: '500px' },
                    objectFit: 'contain',  // Ajuste da imagem para não cortar nem distorcer
                    borderRadius: '8px',
                    mx: 'auto',
                  }}
                />

                <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                  {imagem.nomeOriginal}
                </Typography>

                <DownloadAnexoButton tipo='NOTICIA' ida={imagem.path} fileName={imagem.nomeOriginal} />
              </Box>
            ))}
          </Carousel>
        </>
      )}

      {/* Lista de arquivos não-imagem */}
      {outros.length > 0 && (
        <Box mt={4}>
          <Typography variant="h6" color="primary" gutterBottom padding={2}>
            Arquivos para download
          </Typography>
          <List dense>
            {outros.map((arquivo, index) => (
              <ListItem
                key={index}
                secondaryAction={<DownloadAnexoButton tipo='NOTICIA' ida={arquivo.path} fileName={arquivo.nomeOriginal} />}
              >
                <ListItemText primary={arquivo.nomeOriginal} />
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
}
